<template>
  <ValidationObserver
    ref="form"
    v-slot="{}"
    slim
  >
    <form
      role="form"
      class="form-horizontal"
      name="editNumber"
      novalidate=""
      @submit.prevent
    >
      <!-- Name -->
      <Field
        :label="$t('NUMBERS_NAME')"
        :has-tooltip="true"
        :tooltip-text="$t('NUMBERS_NAME_TT')"
      >
        <template #element>
          <ValidationProvider
            v-slot="{ classes }"
            ref="name"
            rules=""
            slim
          >
            <div :class="classes">
              <div class="col-sm-4 col-md-3">
                <input
                  v-model="inputs.name"
                  type="text"
                  name="name"
                  autocomplete="off"
                  class="form-control"
                >
              </div>
            </div>
          </ValidationProvider>
        </template>
      </Field>

      <!-- Tags -->
      <Field
        :label="$t('NUMBERS_TAGS')"
        :has-tooltip="true"
        :tooltip-text="$t('NUMBERS_TAGS_TT')"
      >
        <template #element>
          <ValidationProvider
            v-slot="{ classes }"
            ref="tagRef"
            rules=""
            slim
          >
            <div :class="classes">
              <div class="col-sm-4 col-md-3">
                <TagInput v-model="inputs.tags" />
              </div>
            </div>
          </ValidationProvider>
        </template>
      </Field>

      <!-- Action Buttons -->
      <div class="row m-b-10">
        <div class="col-sm-7 col-md-7 col-sm-offset-3">
          <!-- Submit -->
          <PrimaryButton
            size="sm"
            type="submit"
            :show-loader-on-form="submitting"
            @click="onSubmit"
          >
            {{ $t('SAVE') }}
          </PrimaryButton>

          <!-- Cancel -->
          <button
            class="btn btn-danger btn-sm m-l-15"
            type="button"
            ng-if="!vm.isNumberPool && !vm.currentCampaign"
            @click="onCancel"
          >
            {{ $t('CANCEL') }}
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import CountrySelector from '@/core/components/CountrySelector/CountrySelector.vue';
import MultipleToggle from '@/core/components/MultipleToggle/MultipleToggle.vue';
import MultiSelect from '@/core/components/MultiSelect/MultiSelect.vue';
import NzToggle from '@/core/components/nzToggle/nzToggle.vue';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown.vue';
import { computed, defineComponent, reactive } from 'vue';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import TagInput from './TagInput.vue';
export default defineComponent({
  name: 'NumberForm',
  components: {
    CountrySelector,
    NzToggle,
    MultipleToggle,
    MultiSelect,
    SearchableDropdown,
    TagInput
  },
  props: {
    currentNumber: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean
    }
  },
  setup(props) {
    const inputs = reactive({
      name: props.currentNumber?.name,
      tags: Array.from(props.currentNumber?.tags || [])
    });

    const number = computed(() => props.currentNumber);

    return {
      inputs,
      number
    };
  },
  computed: {
    output() {
      return {
        ...this.currentNumber,
        ...this.inputs
      };
    }
  },
  methods: {
    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (!valid) return this.$emit('error', this.$refs.form);
      this.$emit('input', this.output);
    },
    onCancel() {
      this.$emit('cancel', this.currentNumber);
    }
  },
  i18n: {
    messages,
    sharedMessages
  }
});
</script>
